module.exports = __webpack_public_path__ + "img/train.8f48d0e0.svg";